import Icon from '@mui/icons-material/MapRounded';
import LocationsList from './LocationsList';

export default {
    list: LocationsList,
    icon: Icon,
};
